import Modal from "aldoo-ra/Modal"

export default function PaymentSuccess({ store }) {
  const {
    paymentReceipt,
    emptyCart,
    paymentSuccessVisible,
    setPaymentSuccessVisible,
    getElement,
    getFragment,
  } = store

  const ProductPostPurchase = getElement("product-post-purchase")
  const PaymentSuccessFragment = getFragment("payment-success")

  const handleClose = () => {
    setPaymentSuccessVisible(false)
    emptyCart()

    setTimeout(() => {
      if (window.location.pathname === "/payment-result") {
        window.location.href = "/"
      }
    }, 500)
  }

  if (!paymentSuccessVisible || !paymentReceipt) return null

  const { cart } = paymentReceipt

  return (
    <Modal
      isOpen={paymentSuccessVisible}
      variant="centered"
      className="md:max-w-[550px]"
      onClose={handleClose}
    >
      <PaymentSuccessFragment store={store}>
        {ProductPostPurchase && (
          <ProductPostPurchase
            store={store}
            product_id={cart[0].product_id}
            onAction={handleClose}
          />
        )}
      </PaymentSuccessFragment>
    </Modal>
  )
}
